import { User } from '@prisma/client'
import React from 'react'
import { CommonClient } from '~/agents/common/client'
import { OnboardingValues } from '~/agents/executiveAssistant/common'
import { AppSessionType } from '~/features/appSession/common'
import { LABEL_SUGGESTIONS } from '../objects'
import { StepAbilities } from './components/StepAbilities'
import { StepCalendarProviders } from './components/StepCalendarProviders'
import { StepEmailProviders } from './components/StepEmailProviders'
import { StepGmailAuthorizations } from './components/StepGmailAuthorizations'
import { StepGoogleCalendarAuthorizations } from './components/StepGoogleCalendarAuthorizations'
import { StepLabels } from './components/StepLabels'

type Props = {
  user: User
  appSession: AppSessionType
  onSubmit: () => void
}

export const Onboarding: React.FC<Props> = ({ user, appSession, onSubmit }) => {
  const valuesDefault: Partial<OnboardingValues> = {
    emailServices: {
      provider: 'google',
    },
    calendarServices: {
      provider: 'google',
    },
    labels: LABEL_SUGGESTIONS.filter(label => label.default).map(
      label => label.value,
    ),
  }

  return (
    <>
      <CommonClient.Onboarding.Wrapper<OnboardingValues>
        appSession={appSession}
        valuesDefault={valuesDefault}
        onSubmitted={onSubmit}
        steps={[
          {
            key: 'abilities',
            content: props => <StepAbilities {...props} />,
          },
          {
            key: 'labels',
            content: props => <StepLabels user={user} {...props} />,
            isVisible: values => !!values.abilities?.labelEmails,
          },
          {
            key: 'emailServices',
            content: props => <StepEmailProviders user={user} {...props} />,
          },
          {
            key: 'authorizations',
            content: props => (
              <StepGmailAuthorizations user={user} {...props} />
            ),
            isVisible: values =>
              values.emailServices?.provider === 'google' &&
              !!values.emailServices.accountGmail,
          },
          {
            key: 'calendarServices',
            content: props => <StepCalendarProviders user={user} {...props} />,
          },
          {
            key: 'googleCalendarSettings',
            content: props => (
              <StepGoogleCalendarAuthorizations
                appSession={appSession}
                user={user}
                {...props}
              />
            ),
            isVisible: values =>
              values.calendarServices?.provider === 'google' &&
              !!values.calendarServices?.accountGoogleCalendar,
          },
        ]}
      ></CommonClient.Onboarding.Wrapper>
    </>
  )
}
